// ----------------------------------------------------------------------------
// Section: Video/Image Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Script
import 'snippets/background-media/background-media';

// Styles
import './_video-image-banner.scss';
